import { useQuery } from '@tanstack/react-query';

import { fetchGetFundingRequirements } from '../../../../api/lending/edge';
import { useGetFormalOffers } from '../../../../api/lending/lapiHooks';
import { useStateKey } from '../../../../hooks/useStateKey.hook';
import { checkAnyRequirementsVisible } from '../../Dashboard.helpers';

export const useGetSecurityCheckRequirements = () => {
  const { stateKey } = useStateKey();
  const { formalOffers, loadingFormalOffers } = useGetFormalOffers();

  const firstIwocapayOffer = formalOffers?.formal_offers?.find(
    (offer) => offer.product_type === 'iwocapay',
  );

  const { data, isLoading } = useQuery({
    queryKey: [
      'fetchGetFundingRequirementsDashboard',
      stateKey,
      firstIwocapayOffer?.offer_id,
    ],
    queryFn: () =>
      fetchGetFundingRequirements({
        stateKey: stateKey!,
        offerId: firstIwocapayOffer?.offer_id!,
      }),
    enabled: Boolean(stateKey) && Boolean(firstIwocapayOffer),
  });

  const fundingRequirement = data?.data || null;

  const isAnyRequirementVisible = checkAnyRequirementsVisible(
    fundingRequirement,
    ['onfido_check', 'add_default_payment_method', 'major_shareholders_check'],
  );

  return {
    isAnyRequirementVisible,
    fundingRequirement,
    loadingFundingRequirement: isLoading || loadingFormalOffers,
  };
};
